module.exports = __webpack_public_path__ + "img/SouthAustraliaMap_Base.b4787f3c.png";